<div class="layout">
  <app-header></app-header>
  @if (banner(); as b) {
    <div class="message app-banner" [ngClass]="'banner-' + b.severity">
      <div class="content">
        <span>{{ b.message }}</span>
      </div>
      @if (b.dismissible !== false) {
        <button type="button" class="banner-close" (click)="dismissBanner()" aria-label="Dismiss notification">
          <i class="app-icon app-icon-times"></i>
        </button>
      }
    </div>
  }
  @if ((qbStatus$ | async) === IsConnectedStatus.disconnected && !disconnectedMessageClosed) {
    <div class="message disconnected">
      <div class="content">
        <span>Quickbooks is disconnected. The app won't function correctly.</span>
        <app-qb-button [height]="30" [width]="171.3"></app-qb-button>
      </div>
    </div>
  }
  <div class="layout-container relative">
    <div class="layout-shell">
      <app-sidebar></app-sidebar>
      <div class="layout-content">
        <app-toast position="bottom-center" />
        <app-confirmation-dialog />
        <router-outlet></router-outlet>
      </div>
    </div>
    @if (isLoading$()) {
      <app-spinner />
    }
  </div>
</div>
